// externals
import * as React from 'react';
import { connect } from 'react-redux';

// libraries
import { navigateTo } from '@makemydeal/dr-activities-common';
import { onOpenLeadFormModal } from '@makemydeal/dr-activities-lead-form';

// components
import SubaruGTPSummaryUI from './SubaruGTPSummaryUI';
import { default as SubaruGTPSummaryUILegacy } from './SubaruGTPSummaryUI.old';

// interfaces/types
import { IManualSummaryUIDispatchProps, IGTPSummaryUIStateProps, IManualSummaryUIProps } from './SubaruGTPSummaryUI';
import { IRootProps } from '../../../../components/RootProps';

// selectors
import * as tradeInSelectors from '../../../../store/mmd/tradeIn';

// actions
import * as tradeInComponentActionCreators from '../../../../store/actionCreators';

// consts/enums
import { Actions as types } from '../../../../store/actions';

// utils
import { isLeadFormSubmittedSuccess } from '../../../../store/mmd/leadForm';
import { getNextCardDetails, getNextStepInfo } from '../../../../store/mmd/navigationCard';
import * as tradeInRoutes from '../../../../utils/routes';

// config
// import config from '../../../store/mmd/config';
import { isDealerUser, isDeskingUser, isShowroomExperience } from '../../../../utils/configUtils';

import * as tradeInActionCreators from '../../../../store/actionCreators';
import * as dealerSelectors from '../../../../store/mmd/dealerSelectors';
import {
    getTradeInSelectors,
    getUniqueEstimateOption,
    processStepperRoutesSubaruGTP
} from '../../../../utils/tradeInDecisionLogic';
import { getBackRouteOfLoanBalance } from '../../../../utils/tradeUtils';
import { STEPPER_ROUTES } from '../../../../utils';
import * as globalConfigFeatureToggleSelectors from '../../../../store/globalConfigFeatureToggles';

const mapStateToProps = (
    state: any,
    ownProps: IRootProps
): IGTPSummaryUIStateProps & { isSubaruGTPSharedComponentsEnabled?: boolean } => {
    const { tradeIn, tradeInState } = tradeInSelectors.getTradeInState(state, ownProps.tradeIndex);
    const cardDetails = getNextCardDetails(state);
    
    const shouldIncludeTradeIn = tradeInSelectors.getShouldIncludeTradeIn(tradeIn);
    const isLeadFormSubmitted = isLeadFormSubmittedSuccess(state);
    const tradePaymentFailed = tradeInSelectors.getTradePaymentFailed(tradeInState);
    const vehicleMileage = tradeInSelectors.getTradeInVehicleMileage(tradeIn);
    const vehicleCondition = tradeInSelectors.getTradeInVehicleCondition(tradeIn);
    const year = tradeInSelectors.getTradeInVehicleYear(tradeIn);
    const make = tradeInSelectors.getTradeInVehicleMakeName(tradeIn);
    const model = tradeInSelectors.getTradeInVehicleModelName(tradeIn);
    const tradeInValue = tradeInSelectors.getTradeInValue(tradeIn, true);
    const loanBalance = tradeInSelectors.getTradeInAmountOwed(tradeIn);
    const isAmdLienPayoffQuoteSpOnSPEnabled = tradeInSelectors.isAmdLienPayoffQuoteEnabled(state);
    const calculatedTradeInValue = tradeInValue - loanBalance;
    const userIsDealer = isDealerUser(ownProps.config);
    const userIsDesking = isDeskingUser(ownProps.config);
    const dealerPhoneNumber = dealerSelectors.getDealerPhone(state);
    const isLeadFormEnabled = tradeInSelectors.shouldShowLeadForm(state);
    const isSalesView = isShowroomExperience(ownProps.config);
    const isMultiTradeEnabled = tradeInSelectors.isMultiTradeInsEnabled(state);

    const stepperRoutes = processStepperRoutesSubaruGTP(
        state,
        STEPPER_ROUTES.summarySubaruGtp,
        isSalesView,
        isAmdLienPayoffQuoteSpOnSPEnabled
    );
    const ghostVinDealerConfig = dealerSelectors.isGhostVinDealerEnabled(state);
    const isGhostVinEnabled = globalConfigFeatureToggleSelectors.isGhostVinEnabled();
    const nextStepInfo = getNextStepInfo(state);
    const showActionButton = nextStepInfo ? true : false;
    const actionButtonText = nextStepInfo ? nextStepInfo.title : '';
    const tradeInAssertionSelectors = getTradeInSelectors(state, isSalesView);
    const { hasUniqueOption: hasUniqueEstimateOption } = getUniqueEstimateOption(tradeInAssertionSelectors, isSalesView);
    const selectedLoanBalanceOption = tradeInSelectors.getTradeInSelectedLoanBalanceOption(tradeIn);
    const hasOpenLoan = tradeIn?.hasOpenLoan ?? null;
    const fallbackBackRoute = hasUniqueEstimateOption ? tradeInRoutes.TRADE_VEHICLE_INFO : tradeInRoutes.TRADE_IN_DECISION;
    const backRoute = isAmdLienPayoffQuoteSpOnSPEnabled
        ? getBackRouteOfLoanBalance(selectedLoanBalanceOption, hasOpenLoan)
        : fallbackBackRoute;
    const isSubaruGTPSharedComponentsEnabled = tradeInSelectors.isSubaruGTPSharedComponentsEnabled(state);
    const expirationDate = tradeInSelectors.getSubaruGtpExpirationDate(state);

    return {
        cardDetails,
        isTradeLeadFormEnabled: true,
        isLeadFormSubmitted,
        tradePaymentFailed,
        vehicleMileage,
        vehicleCondition,
        year,
        make,
        model,
        tradeInValue,
        loanBalance,
        calculatedTradeInValue,
        userIsDealer,
        userIsDesking,
        dealerPhoneNumber,
        isLeadFormEnabled,
        stepperRoutes,
        ghostVinDealerConfig,
        isGhostVinEnabled,
        actionButtonText,
        showActionButton,
        backRoute,
        isMultiTradeEnabled,
        shouldIncludeTradeIn,
        isSubaruGTPSharedComponentsEnabled,
        expirationDate,
        urlPath: ownProps.tradeInRoute
    };
};

const mapDispatchToProps = (dispatch: any, ownProps: IRootProps): IManualSummaryUIDispatchProps => {
    return {
        goToRoute: (route) => {
            dispatch(navigateTo(route));
        },
        editTradeIn: () => {
            dispatch(tradeInComponentActionCreators.trackEditIconOnCompletionClicked());
        },
        addRemoveTradeToDeal: (shouldIncludeTradeIn) => {
            if (shouldIncludeTradeIn) {
                dispatch(tradeInComponentActionCreators.removeTradeToDeal());
            } else {
                dispatch(tradeInComponentActionCreators.addTradeToDeal());
            }
        },
        termsDetailsClicked: () => {
            dispatch(tradeInComponentActionCreators.trackTermsDetailsOnCompletionClicked());
        },
        loadLeadForm: (skipLink) => {
            dispatch(
                onOpenLeadFormModal(
                    'Almost to Your Trade-In Value',
                    "Your trade-in value is on the next page.  Let's submit your deal status to unlock.",
                    skipLink,
                    types.TRADE_IN_LEAD_SUBMITTED,
                    types.TRADE_IN_PERFORM_UPDATE,
                    types.REMOVE_TRADE_IN_AND_CLOSE_MODAL
                )
            );
        },
        dispatchAnalytics: (type, description) => {
            dispatch(tradeInComponentActionCreators.dispatchAnalytics(type, description));
        },
        tradeInEstimateDisplayed: () => {
            dispatch(tradeInComponentActionCreators.sendTradeInEstimateDisplayedAnalytics());
        },
        removeTrade: () => {
            dispatch(tradeInActionCreators.removeTradeIn());
            dispatch(navigateTo(tradeInRoutes.TRADE_IN));
        },
        goToNextStep: () => {
            dispatch((dispatch, getState) => {
                const state = getState();
                const nextStepInfo = getNextStepInfo(state);
                if (nextStepInfo) {
                    dispatch(tradeInComponentActionCreators.tradeInCompletedContinue());
                    dispatch(tradeInComponentActionCreators.continueToNextActivityPress(nextStepInfo.route));
                    dispatch(navigateTo(nextStepInfo.route));
                }
            });
        },
        cdlBackButtonClicked: () => {
            dispatch(tradeInComponentActionCreators.cdlBackButtonClicked('Summary'));
        }
    };
};

type IManualSummaryWrapperProps = IManualSummaryUIProps & { isSubaruGTPSharedComponentsEnabled?: boolean };

const ManualSummaryWrapper: React.FC<IManualSummaryWrapperProps> = ({ isSubaruGTPSharedComponentsEnabled, ...props }) =>
    isSubaruGTPSharedComponentsEnabled ? <SubaruGTPSummaryUI {...props} /> : <SubaruGTPSummaryUILegacy {...props} />;

const SubaruGTPSummary = connect(mapStateToProps, mapDispatchToProps)(ManualSummaryWrapper);

export default SubaruGTPSummary;
